import { useEffect, useState } from "react";
import { Share2, Music4, MapPin, Trophy } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { StoryShareModal } from "./StoryShareModal";
import { Button } from "./ui/button";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function CityRecap({ autoOpen = false }) {
  const { user } = useAuth();
  const [r, setR] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/virtucity/recap").then(({ data }) => { setR(data); if (autoOpen && data.has_data) setOpen(true); }).catch(() => {}); }, [autoOpen]);
  if (!r || !r.has_data || !user) return null;
  const img = `${BACKEND}/api/og/story/recap/${encodeURIComponent(user.username)}.png?week=${r.week}&v=${r.plays}_${r.vc_earned}`;
  return (
    <div className="rounded-2xl border border-gold/30 p-5 mb-4 bg-[radial-gradient(ellipse_at_top_right,rgba(212,175,55,.18),transparent_60%)]" data-testid="vc-recap-card">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="text-[11px] tracking-[0.25em] text-gold font-semibold">YOUR WEEK IN VIRTUCITY · {r.week}</div>
          <div className="flex flex-wrap gap-2 mt-3 text-sm">
            <span className="surface-2 rounded-full px-3 h-8 flex items-center gap-1.5" data-testid="vc-recap-plays"><Music4 size={13} className="text-gold" />{r.plays} club {r.plays === 1 ? "play" : "plays"}</span>
            <span className="surface-2 rounded-full px-3 h-8 flex items-center gap-1.5" data-testid="vc-recap-venues"><MapPin size={13} className="text-gold" />{r.venues} {r.venues === 1 ? "venue" : "venues"}</span>
            <span className="surface-2 rounded-full px-3 h-8 flex items-center gap-1.5" data-testid="vc-recap-rank"><Trophy size={13} className="text-gold" />{r.best_rank ? `Best #${r.best_rank}` : "Unranked"}</span>
            {(r.vc_earned > 0 || r.fame_earned > 0) && <span className="rounded-full px-3 h-8 flex items-center bg-gold/15 text-gold font-semibold" data-testid="vc-recap-rewards">+{r.vc_earned} VC · +{r.fame_earned} Fame</span>}
          </div>
        </div>
        <Button onClick={() => setOpen(true)} className="btn-gold text-black rounded-full" data-testid="vc-recap-share"><Share2 size={14} className="mr-1.5" />Share to Story</Button>
      </div>
      {open && <StoryShareModal username={user.username} imageUrl={img} filename={`virtucity-week-${r.week}.png`} link={`https://virtustars.com/${user.username}`} onClose={() => setOpen(false)} />}
    </div>
  );
}
